<script>
import TagInput from '@app/components/TagInput.vue';

export default {
  components: { TagInput },
  data() {
    return {
      isLoading: false,
      membership: {
        tags: [],
      },
    };
  },
  computed: {
    currentMembership() {
      return this.$store.state.memberships.current;
    },
  },
  created() {
    this.hydrate();
  },
  methods: {
    hydrate() {
      this.membership.tags = this.currentMembership.tags || [];
    },
    handle() {
      const membershipData = { ...this.membership };

      this.isLoading = true;
      this.$store.dispatch('memberships/update', {
        uuid: this.currentMembership.uuid,
        membershipData,
        isCurrent: true,
      })
        .then(() => this.$showMessage.success())
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<template>
  <AppFeatureWrapper tag="section">
    <template #title>
      Gérez les étiquettes
    </template>
    <template #content>
      <p>
        Les étiquettes sont un très bon moyen pour vous permettre d'organiser vos abonnements.<br/>
        Elles ne sont pas visibles par vos visiteurs ou apprenants.
      </p>
    </template>
    <template #form>
      <form class="box" @submit.prevent="dataIsValid(isLoading) && handle()">
        <b-field label="Étiquettes">
          <TagInput
            v-model="membership.tags"
            placeholder="Ajoutez votre étiquette puis tapez sur Entrée"
            :autocomplete="false"
          />
        </b-field>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </template>
  </AppFeatureWrapper>
</template>

<style scoped>
.tag-autocomplete>>>.dropdown-item.is-disabled {
  opacity: 1;
  cursor: pointer;
}

.tag-list {
  display: flex;
  gap: 6px;
}
</style>
